import React from 'react'
import styled from 'styled-components';
import Chart from './Chart';

const Root = styled.div`
/* width: calc(100%-35%); */
width: 60%;



`;
const Container = styled.div`
  /* padding: 40px 40px 0px 40px; */
  padding: 40px 35px;

`;

const Breadcrumbs = styled.div`
  padding: 20px 20px;
  font-size: 18px;
  background-color: #fff;
  border-top: 1px solid #d8dbe0;
`;

const CardSection = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid transparent;
    background: linear-gradient(black 0px, black 0px) padding-box padding-box, linear-gradient(rgb(167, 62, 231), rgb(255, 0, 0)) border-box border-box;
border-radius:8px;
`;

const Card = styled.div`

  display: flex;
  flex-direction: column;
  ${(p) =>
    p.color &&
    `
background-color:${p.color} ;
`};
  padding: 20px;
  border-radius: 10px;
  color: #fff;
`;

const TextWrapper = styled.div`
  color: #fff;
  margin-bottom: 20px;
`;
const BoldText = styled.div`
  /* font-size: 22px;
  font-weight: bold;
  margin-right: 10px; */
  font-style: normal;
font-weight: 600;
font-size: 28px;
line-height: 34px;
`;
const Text = styled.div`
  display: flex;
  align-items: center;
  font-weight: 300;
`;

const Wrapper = styled.div`

width: 50rem;
max-height: 350px;
/* width:calc(50% - 20px);
padding:80px;
background-color:#fff;
height: 400px; */
`;

const DashboardGraph = () => {
  return (
    <Root>
    <Container>
      <CardSection>
        <Card color="#000">
          <TextWrapper>
            <Text>
              <BoldText>$102.5 </BoldText> 
              {/* (-12.4%{" "}
              <i class="fa-solid fa-arrow-down"></i>) */}
            </Text>
            <Text style={{ marginTop: "5px" }}>Total Sold</Text>
          </TextWrapper>
       
          <Wrapper>
           <Chart />
          </Wrapper>
        </Card>
      </CardSection>
    </Container>
  </Root>
  )
}

export default DashboardGraph